@let show = fbLinkShow$ | async;
@let isPlain = variant() === 'plain';

<ng-template #fbNavButton>
  <a
    id="fb-root"
    class="w-[60px] aspect-square flex justify-center items-center rounded-full cursor-pointer mx-3 elevation-6 z-[10000] group relative"
    [style.background-color]="FB_BadgeColor"
    [href]="fbLink"
    target="_blank"
    (click)="handleClick($event)"
    (mouseenter)="startHoverTimer()"
    (mouseleave)="clearHoverTimer()"
  >
    <svg width="36" height="36" viewBox="0 0 36 36">
      <path
        fill="white"
        d="M1 17.99C1 8.51488 8.42339 1.5 18 1.5C27.5766 1.5 35 8.51488 35 17.99C35 27.4651 27.5766 34.48 18 34.48C16.2799 34.48 14.6296 34.2528 13.079 33.8264C12.7776 33.7435 12.4571 33.767 12.171 33.8933L8.79679 35.3828C7.91415 35.7724 6.91779 35.1446 6.88821 34.1803L6.79564 31.156C6.78425 30.7836 6.61663 30.4352 6.33893 30.1868C3.03116 27.2287 1 22.9461 1 17.99ZM12.7854 14.8897L7.79161 22.8124C7.31238 23.5727 8.24695 24.4295 8.96291 23.8862L14.327 19.8152C14.6899 19.5398 15.1913 19.5384 15.5557 19.8116L19.5276 22.7905C20.7193 23.6845 22.4204 23.3706 23.2148 22.1103L28.2085 14.1875C28.6877 13.4272 27.7531 12.5704 27.0371 13.1137L21.673 17.1847C21.3102 17.4601 20.8088 17.4616 20.4444 17.1882L16.4726 14.2094C15.2807 13.3155 13.5797 13.6293 12.7854 14.8897Z"
      ></path>
    </svg>

    @if (showCloseButton$ | async) {
      <button
        (click)="toggleFbButton($event)"
        class="absolute -top-2 -right-2 w-6 h-6 bg-gray-800 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <span class="text-white text-sm">&times;</span>
      </button>
    }
  </a>
</ng-template>

@if (show && !isPlain) {
  <div
    #boundary
    class="fixed pointer-events-none w-full h-full top-0 left-0"
  ></div>
  <div
    class="fixed right-3 bottom-6"
    cdkDrag
    [cdkDragBoundary]="boundary"
    (cdkDragStarted)="handleDragStart()"
    (cdkDragEnded)="handleDragEnd()"
  >
    <ng-template [ngTemplateOutlet]="fbNavButton" />
  </div>
} @else if (!show && isPlain) {
  <ng-template [ngTemplateOutlet]="fbNavButton" />
}
